<template>
  <div class="banckAccountInfoDetail">
    <van-form label-width="120px" :show-error="false" @submit="onSubmit">
      <van-field
        v-model="form.CustomerNumber"
        :label="$t.bankAccount.customerNumber"
        label-class="number-label"
        :placeholder="$t.meta.input"
        @blur="getCustomerInfoSearchList"
        required
        :rules="formRule"
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="onCopy(form.CustomerNumber)"
            :disabled="!form.CustomerNumber ? true : false"
            native-type="button"
            >{{ $t.meta.copy }}</van-button
          >
        </template>
      </van-field>

      <van-field
        v-model="form.CompanyName"
        :label="$t.bankAccount.customerName"
        :placeholder="$t.meta.input"
        v-if="form.CompanyName"
        disabled
      />

      <van-field
        v-model="form.AddUserName"
        :label="$t.bankAccount.clerk"
        :placeholder="$t.meta.input"
        v-if="form.AddUserName"
        disabled
      />

      <div class="title">{{ $t.meta.basicTitle }}</div>

      <van-field
        v-model="form.AccountName"
        :label="$t.bankAccount.accountName"
        :placeholder="$t.meta.input"
        type="textarea"
        rows="3"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.BankName"
        :label="$t.bankAccount.bankName"
        :placeholder="$t.meta.input"
        type="textarea"
        rows="3"
      />

      <van-field
        v-model="form.Currency"
        :label="$t.bankAccount.currency"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.BankRegion"
        :label="$t.bankAccount.bankRegion"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.AccountNo"
        :label="$t.bankAccount.bankNumber"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.SwiftCodeBankNo"
        label="Swift Code"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.BankAddress"
        :label="$t.bankAccount.bankAddress"
        :placeholder="$t.meta.input"
        type="textarea"
      />

      <van-field
        v-model="form.CompanyAddressEn"
        :label="$t.bankAccount.companyAddressEn"
        :placeholder="$t.meta.input"
        type="textarea"
      />

      <van-field
        v-model="form.EnterpriseId"
        :label="$t.bankAccount.enterpriseId"
        :placeholder="$t.meta.input"
      />

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.save
        }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image);

export default {
  name: "banckAccountInfoDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      isEdit: false,
      form: {},
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
    };
  },
  created() {
    const { IsEdit } = this.$route.query;
    this.isEdit = IsEdit;
    if (IsEdit) {
      var data = JSON.parse(localStorage.getItem("banckAccountInfoDetail"));
      this.form = data;
      this.getCustomerInfoSearchList();
    } else {
      this.form = {
        BankId: "",
        AddUserName: "",
        CustomerNumber: "",
        CompanyName: "",
        Currency: "",
        AccountName: "",
        BankName: "",
        BankRegion: "",
        AccountNo: "",
        SwiftCodeBankNo: "",
        BankAddress: "",
        CompanyAddressEn: "",
        EnterpriseId: "",
      };
    }
  },
  methods: {
    getCustomerInfoSearchList() {
      return new Promise((resolve) => {
        if (this.form.CustomerNumber) {
          this.$commonMethod.showLoading();
          let param = {
            CustomerNumber: this.form.CustomerNumber,
            CompanyId: this.CompanyId,
          };
          this.$api.customerManagement
            .getCustomerInfoSearchList(param)
            .then((res) => {
              if (res.data && res.data.length > 0) {
                this.form.CompanyName = res.data[0].CompanyName;
              } else {
                this.form.CompanyName = this.$t.bankAccount.none;
              }
              this.$forceUpdate();
              this.$commonMethod.hideLoading();
              resolve(true);
            })
            .catch((error) => {
              this.$commonMethod.hideLoading();
              this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
                msg: error.message,
              });
            });
        } else {
          this.form.CompanyName = this.$t.bankAccount.none;
        }
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.CompanyId = this.CompanyId;
      param.UserId = this.UserId;
      var request = null;
      if (this.isEdit) {
        request = this.$api.customerManagement.editBankAccountInfo(param);
      } else {
        request = this.$api.customerManagement.addBankAccountInfo(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.isEdit ? res.message : res.data,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.banckAccountInfoDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #999 !important;
      -webkit-text-fill-color: #999 !important;
    }
  }
}
</style>
